import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { __PRODUCTION__ } from "./lib/__PRODUCTION__.js";
import { pascalCase } from "./lib/pascalCase.js";
var TODOSliceComponent = __PRODUCTION__ ? function () {
  return null;
} : function (_ref) {
  var slice = _ref.slice;
  var type = "slice_type" in slice ? slice.slice_type : slice.type;
  React.useEffect(function () {
    console.warn("[SliceZone] Could not find a component for Slice type \"".concat(type, "\""), slice);
  }, [slice, type]);
  return /* @__PURE__ */jsxs("section", {
    "data-slice-zone-todo-component": "",
    "data-slice-type": type,
    children: ["Could not find a component for Slice type “", type, "”"]
  });
};
var SliceZone = function SliceZone(_ref2) {
  var _ref2$slices = _ref2.slices,
    slices = _ref2$slices === void 0 ? [] : _ref2$slices,
    _ref2$components = _ref2.components,
    components = _ref2$components === void 0 ? {} : _ref2$components,
    resolver = _ref2.resolver,
    _ref2$defaultComponen = _ref2.defaultComponent,
    defaultComponent = _ref2$defaultComponen === void 0 ? TODOSliceComponent : _ref2$defaultComponen,
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? {} : _ref2$context;
  var renderedSlices = React.useMemo(function () {
    return slices.map(function (slice, index) {
      var type = "slice_type" in slice ? slice.slice_type : slice.type;
      var Comp = components[type] || defaultComponent;
      if (resolver) {
        var resolvedComp = resolver({
          slice: slice,
          sliceName: pascalCase(type),
          i: index
        });
        if (resolvedComp) {
          Comp = resolvedComp;
        }
      }
      var key = "id" in slice && slice.id ? slice.id : "".concat(index, "-").concat(JSON.stringify(slice));
      return /* @__PURE__ */jsx(Comp, {
        slice: slice,
        index: index,
        slices: slices,
        context: context
      }, key);
    });
  }, [components, context, defaultComponent, slices, resolver]);
  return /* @__PURE__ */jsx(Fragment, {
    children: renderedSlices
  });
};
export { SliceZone, TODOSliceComponent };